import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline'; // Recommended for baseline styles

import * as Sentry from "@sentry/react";

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#2c8f6d',
      light: '#5fb89a',
      dark: '#1e604c',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#f07c6c',
      light: '#f7a396',
      dark: '#a85247',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f5f7f6',
      paper: '#ffffff',
    },
    text: {
      primary: '#2b2b2b',
      secondary: '#555f5c',
    },
    warning: {
      main: '#e2b85b',
      contrastText: '#2b2b2b',
    },
    divider: '#d6dfdc',
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration()
  ],
  tracesSampleRate: 1.0,
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'development',
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline /> 
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
